import { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import { membresias } from "@/lib/membresias";
import HeroSection from "./components/HeroSection";
import NewsTicker from "./components/NewsTicker";
import LatestNews from "./components/LatestNews";
import FeaturedNews from "./components/FeaturedNews";
import ThematicSections from "./components/ThematicSections";
import SustainabilitySection from "./components/SustainabilitySection";
import NewsletterSection from "./components/NewsletterSection";
import AdSection from "./components/AdSection";
import ScrollToTopButton from "../../components/feature/ScrollToTopButton";
import SEO from "@/components/SEO";
import InterviewsSection from "./components/InterviewsSection";

function HomeSearchBar() {
  const [query, setQuery] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim()) {
      navigate(`/actualidad?search=${encodeURIComponent(query.trim())}`);
    }
  };

  return (
    <section className="bg-[#F4F7FB] pt-3 md:pt-6 pb-1 md:pb-2">
      <div className="max-w-screen-xl mx-auto px-4 md:px-6">
        <form onSubmit={handleSubmit} className="relative max-w-2xl mx-auto">
          <div className="relative flex items-center bg-white rounded-xl border border-slate-200 shadow-sm hover:shadow-md transition-shadow">
            <div className="pl-4">
              <i className="ri-search-line text-slate-400 text-lg" />
            </div>
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Buscar noticias, aerolíneas, aeropuertos..."
              className="flex-1 px-3 py-3.5 bg-transparent text-sm text-slate-700 placeholder-slate-400 focus:outline-none"
              style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
            />
            <button
              type="submit"
              className="mr-2 px-5 py-2 bg-[#0B1F3A] hover:bg-[#0d2547] text-white text-sm font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
            >
              Buscar
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}

export default function Home() {
  const siteUrl = (typeof window !== 'undefined' && window.location?.origin) || 'https://aviacioninsightrd.com';
  const logoUrl = "https://public.readdy.ai/ai/img_res/edited_118127e0540aad95b23299328e0f8d5c_bd5f8c22.jpg";
  const [latestIds, setLatestIds] = useState<number[]>([]);

  const handleLatestLoaded = useCallback((ids: number[]) => {
    setLatestIds(ids);
  }, []);

  return (
    <main className="min-h-screen" style={{ fontFamily: "'Inter', sans-serif" }}>
      <SEO
        jsonLdSchemas={[
          {
            "@type": "NewsMediaOrganization",
            name: "Aviación Insight RD",
            url: siteUrl,
            logo: logoUrl,
            founder: {
              "@type": "Person",
              name: "Carmen Bretón",
              jobTitle: "Periodista y analista aeronáutica",
            },
            description: "Portal líder en noticias y análisis del sector aeronáutico en República Dominicana y el Caribe.",
            memberOf: membresias.map((m) => ({
              "@type": "Organization",
              name: m.nombre,
              alternateName: m.sigla,
              url: m.href,
            })),
            areaServed: ["DO", "Caribbean"],
            knowsAbout: ["Aviación", "Aeronáutica", "Aeropuertos", "Aerolíneas", "Sostenibilidad Aérea"],
          },
          {
            "@type": "WebSite",
            name: "Aviación Insight RD",
            url: siteUrl,
            potentialAction: {
              "@type": "SearchAction",
              target: `${siteUrl}/actualidad?search={search_term_string}`,
              "query-input": "required name=search_term_string",
            },
          },
        ]}
      />
      <Navbar />
      <HeroSection />
      <HomeSearchBar />
      <NewsTicker />
      <LatestNews onArticlesLoaded={handleLatestLoaded} />
      <FeaturedNews excludeIds={latestIds} />
      <InterviewsSection />
      <AdSection variant="top" />
      <ThematicSections />
      <SustainabilitySection />
      <NewsletterSection />
      <AdSection variant="bottom" />
      <Footer />
      <ScrollToTopButton />
    </main>
  );
}